var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceLoginAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#009999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 27C33 27.551 32.552 28 32 28H25.087H24.913H18C17.448 28 17 27.551 17 27V19C17 18.449 17.448 18 18 18H32C32.552 18 33 18.449 33 19V27ZM32 16H18C16.346 16 15 17.346 15 19V27C15 28.654 16.346 30 18 30H24V32H20C19.45 32 19 32.45 19 33C19 33.55 19.45 34 20 34H30C30.55 34 31 33.55 31 33C31 32.45 30.55 32 30 32H26V30H32C33.654 30 35 28.654 35 27V19C35 17.346 33.654 16 32 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceLoginAlerts);
export default __webpack_public_path__ + "static/media/device-login-alerts.c9aefeabd29823754fe47ed71d780e13.svg";
export { ForwardRef as ReactComponent };